import ModalCustom from '../utils/ModalCustom/ModalCustom';
import React, { useState } from 'react';
import { Button, Form, Input } from 'antd';
import { useTranslation } from '../../i18n/i18n';
import { PlusOutlined } from '@ant-design/icons';
import { tenantApi } from '../../api/tenant.api';

interface CreateTenantModalProps {
  onSuccess?: () => void;
}
const CreateTenantModal = ({ onSuccess }: CreateTenantModalProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm<{ name: string }>();
  const { t } = useTranslation('tenants', { keyPrefix: 'modalCreate' });

  const handleClick = async () => {
    let values: { name: string };
    try {
      values = await form.validateFields();
    } catch {
      return;
    }
    setLoading(true);
    try {
      await tenantApi.createTenant(values.name);
      form.resetFields();
      setIsModalOpen(false);
      onSuccess?.();
    } catch (e) {
      throw e;
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button type={'primary'} icon={<PlusOutlined />} onClick={() => setIsModalOpen(true)}>
        {t('title')}
      </Button>
      <ModalCustom
        title={t('title')}
        description={t('description')}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        footer={[
          <Button key={'save'} type={'primary'} loading={loading} onClick={handleClick}>
            {t('save')}
          </Button>,
        ]}
      >
        <Form form={form} layout="vertical" onFinish={handleClick}>
          <Form.Item name="name" label={t('name')} rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Form>
      </ModalCustom>
    </>
  );
};

export default CreateTenantModal;
